import { RestResource } from "./common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export enum COMMUNICATION_GROUP {
  ACCOUNT = "Account Communications",
  TRADE = "Trade Communications",
  MARKETING = "Marketing Communications",
  REFERRAL = "Referral Communications",
  CASH = "Cash Communications",
}

export type CommunicationGroupPreferenceType =
  | "email"
  | "pushNotification"
  | "sms"

export class CommunicationGroupPreference extends RestResource {
  static onInitialize = (_obj: CommunicationGroupPreference) => {
    /* no-op */
  }

  constructor() {
    super()

    CommunicationGroupPreference.onInitialize(this)
  }

  communicationGroupName = ""
  email = false
  externallyVisible = true
  /**
   * @field optional implies that the preference cannot be modified.
   * when optional is true it means the user should be allowed to modify this communication group.
   * when optional is false it means we must send these notifications and the user may not change this.
   *
   * TODO: follow up with backend team to confirm if this is needed.
   **/
  optional = true
  pushNotification = false
  sms = false

  get isSmsVisible() {
    return this.communicationGroupName === COMMUNICATION_GROUP.MARKETING
  }
}

export const COMM_PREFERENCE_DESER: SchemaDeSer<CommunicationGroupPreference> =
  new SchemaDeSerBuilder(CommunicationGroupPreference)
    .ofString("id")
    .ofString("communicationGroupName")
    .ofBoolean("email")
    .ofBoolean("externallyVisible")
    .ofBoolean("optional")
    .ofBoolean("pushNotification")
    .ofBoolean("sms")
    .toDeSer()

export const COMM_PREFERENCE_PARSER = COMM_PREFERENCE_DESER.toParser(
  CommunicationGroupPreference
)
